/**
 * Generate a random alphanumeric voucher code.
 * Format: EWXXXXXXXX (uppercase, no ambiguous chars, no hyphens)
 */
export function generateVoucherCode(prefix = 'EW'): string {
  const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789' // no I, O, 0, 1
  const segment = (len: number) =>
    Array.from({ length: len }, () => chars[Math.floor(Math.random() * chars.length)]).join('')
  return `${prefix}${segment(4)}${segment(4)}`
}

export function generateBatchCodes(quantity: number, prefix = 'EW'): string[] {
  const set = new Set<string>()
  while (set.size < quantity) {
    set.add(generateVoucherCode(prefix))
  }
  return Array.from(set)
}
